import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {markets,market,marketSimple,marketGoods,marketGood,marketPurchases,marketPurchase,
    marketRankLists,marketRecover,marketExport,marketPurchasesOwner,marketPurchasePush} = api

/**
 * 查找
 */
export async function findMarkets(params) {
    return request({url: markets, method: 'get', data: params,})
}
/**
 * 创建
 */
export async function createMarkets(params) {
    return request({url: markets, method: 'post', data: params,})
}
/**
 * 查找详情
 */
export async function findMarket(params) {
    return request({url: market, method: 'get', data: params,})
}

/**
 * 编辑
 */
export async function updateMarket(params) {
    return request({url: market, method: 'put', data: params,})
}
/**
 * 删除
 */
export async function deleteMarket(params) {
    return request({url: market, method: 'delete', data: params,})
}
/**
 * 编辑
 */
export async function updateMarketSimple(params) {
    return request({url: marketSimple, method: 'put', data: params,})
}
/**
 * 恢复
 */
export async function recoverMarket(params) {
    return request({url: marketRecover, method: 'put', data: params,})
}

/**
 * 查询打赏金额
 */
export async function findMarketGoods(params) {
    return request({url: marketGoods, method: 'get', data: params,})
}/**
 * 新增
 */
export async function createMarketGoods(params) {
    return request({url: marketGoods, method: 'post', data: params,})
}

export async function updateMarketGood(params) {
    return request({url: marketGood, method: 'put', data: params,})
}
export async function deleteMarketGood(params) {
    return request({url: marketGood, method: 'delete', data: params,})
}
export async function findMarketPurchases(params) {
    return request({url: marketPurchases, method: 'get', data: params,})
}
export async function createMarketPurchases(params) {
    return request({url: marketPurchases, method: 'post', data: params,})
}
export async function deleteMarketPurchase(params) {
    return request({url: marketPurchase, method: 'delete', data: params,})
}
export async function createMarketPurchasesOwner(params) {
    return request({url: marketPurchasesOwner, method: 'post', data: params,})
}
export async function findMarketRankLists(params) {
    return request({url: marketRankLists, method: 'get', data: params,})
}

export async function expMarket(params) {
    return request({url: marketExport, method: 'get', data: params,})
}
export async function pushMarketPurchase(params) {
    return request({url: marketPurchasePush, method: 'post', data: params,})
}







// WEBPACK FOOTER //
// ./src/services/market.js